<template>
  <jd-dialog class="selectGoodsMonitor" title="选择商品" append-to-body  width="1135px" :visible="isShow" @close="popupClose">
    <div style="margin-top: -4px" v-if="!venderType && GoodsSkuIsflay">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="按spu选择" name="1"></el-tab-pane>
        <el-tab-pane label="按sku选择" name="2"></el-tab-pane>
        <el-tab-pane label="导入sku" name="3"></el-tab-pane>
        <el-tab-pane label="分组sku" name="4"></el-tab-pane>
      </el-tabs>
    </div>
    <div v-else>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="按sku选择" name="2"></el-tab-pane>
        <el-tab-pane label="导入sku" name="3"></el-tab-pane>
        <el-tab-pane label="分组sku" name="4"></el-tab-pane>
      </el-tabs>
    </div>

    <!-- 头部查询表单 -->
    <div class="headSearchForm" v-if="!goodsStateSku&&!leadIntoSku&&!fenzuSku" style="margin-bottom:2px">
      <inputForm v-if="skuSearch" :inputData="inputData1" ref="inputForm" @toParentVal="handleSearch"
        :btnPosition2="true"></inputForm>
      <inputForm v-else :inputData="inputData" ref="inputForm2" @toParentVal="handleSearch" :btnPosition2="true">
      </inputForm>
    </div>
    <!-- 选择商品区块 -->
    <div class="goodsContent" v-if="!goodsStateSku&&!leadIntoSku&&!fenzuSku">
      <!-- 左边盒子 -->
      <div class="left">
        <div class="titleBox">
          <div class="tit" style="flex: 1;">店内商品</div>
          <div>
            <jd-button  @click.prevent="updateGoods" type="text">更新</jd-button>
            <jd-button  style="margin-left: 8px;" @click="allShop()" type="text">按查询结果选择</jd-button>
            <jd-button style="margin-left: 8px;" @click="selectAll()" type="text" >全选</jd-button>
          </div>
        </div>
        <!-- 商品滚动盒子 -->
        <div class="goodsScrollBox" v-loading="tableLoading">
          <!-- <div v-loading="tableLoading"> -->
            <template v-if="goodsList.length == 0">
              <div class="noDataBox">
                <jd-image :src="$globalCdn + '/images/leftOrNoCxt.png'" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <div class="goods" :class="{ isAdd: item.isAdd }" v-for="item in goodsList"
              :key="skuSearch ? item.skuId : item.wareId">
              <img :src="item.logo" class="avar" alt="商品图片" />
              <div class="desc">
                <a :href="item.itemUrl" target="_blank" style="padding-top: 10px;">
                  <p :title="item.wareTitle" class="goodsName">{{ item.wareTitle }}</p>
                </a>
                <div class="foot">
                  <div>
                    <span class="money">￥{{ item.jdPrice }}</span>
                    <span v-if="skuSearch" class="goodsId">sku ID:{{ item.skuId }}</span>
                    <span v-else class="goodsId">商品ID:{{ item.wareId }}</span>
                  </div>
                </div>
              </div>
              <div><img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/add_icon.svg" class="addIcon" alt="添加icon" @click="addGoods(item)" />
              </div>
            </div>
          <!-- </div> -->
        </div>
        <!-- 分页 -->
        <div class="new-pagination-page">
          <el-pagination @size-change="handleLeftSizeChange" @current-change="handleLeftCurrentChange"
            :current-page="currentLeftPage" background small :page-sizes="[5, 10, 50, 100, 500, 1000]"
            :page-size="pageSizeLeft" :pager-count="5" layout="total, sizes, prev, pager, next, jumper"
            class="pagination" :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 右边盒子 -->
      <div class="right">
        <div class="titleBox">
          <span class="tit" style="flex: 1;">已选商品（{{ selectedGoodsList.length }}）</span>
          <!-- <span class="clear" style="right: 42px;" @click="saveGoodsList()">保存分组</span>
          <span class="clear" @click="empty()">清空</span> -->
          <jd-button type="blueText" @click="saveGoodsList()">保存分组</jd-button>
          <jd-button type="blueText" @click="empty()">清空</jd-button>
        </div>
        <!-- 商品滚动盒子 -->

        <div class="goodsScrollBox" v-loading="tableRightLoading">
          <template v-if="selectedGoodsList.length == 0">
            <div class="noDataBox">
              <jd-image :src="$globalCdn + '/images/leftOrNoCxt.png'" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <template>
            <div class="goods" v-for="(item, index) in showSelectedGoodsList"
              :key="skuSearch ? item.skuId : item.wareId + index">
              <img :src="item.logo" class="avar" alt="商品图片" />
              <div class="desc">
                <p :title="item.wareTitle || item.title " class="goodsName">
                  {{ item.wareTitle || item.title }}
                </p>
                <div class="foot">
                  <div>
                    <span class="money">￥{{ item.jdPrice || item.price }}</span>
                    <span v-if="skuSearch" class="goodsId">sku ID:{{ item.skuId }}</span>
                    <span v-else class="goodsId">商品ID:{{ item.wareId }}</span>
                  </div>
                  <!-- <span class="money" v-if="xianz">￥{{ item.price }}</span> -->

                  <div><img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/clear_icon.svg" class="clearIcon" alt="添加icon"
                      @click="clearGoods(item, index)" /></div>
                </div>
              </div>

            </div>
          </template>
        </div>
        <div class="new-pagination-page">
          <!-- 分页 -->
          <el-pagination @size-change="handleRigthSizeChange" @current-change="handleRightCurrentChange"
            :current-page="currentRightPage" small :pager-count="5" background :page-sizes="[5, 10, 50, 100, 500, 1000]"
            :page-size="pageSizeRight" layout="prev, pager, next, jumper" class="pagination"
            :total="selectedGoodsList.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <selectGoodsSku :isShow="goodsStateSku&&!leadIntoSku&&!fenzuSku" :venderId="venderId" :skuSearch="true" :moduleType="true" ref="SelectGoodsSku"

      :selectGoods="SelectGoodsListSku" :xianz="xianz" :limit="limit"></selectGoodsSku>
    <!-- 导入sku -->
    <div v-if="leadIntoSku&&!fenzuSku">
      <div style="margin-bottom: 16px;display: flex;flex-direction: column;height: 48px;">
        <div style="margin-bottom: 16px; height: 16px;display: flex;align-items: center;flex-direction: row;">
        <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/tip/yello.png" style="width: 14px;height: 14px;margin-right: 8px;" alt="">
        <span style="color: #F89F39;">导入的sku在sku列表选中及查看</span>
        </div>
        <div style="width: 14px;height: 14px;margin-right: 8px;display: flex;align-items: center;flex-direction: row;">
          <el-radio v-model="SkuRadio" label="手动输入">手动输入</el-radio>
          <el-radio v-model="SkuRadio" label="上传文件">上传文件</el-radio>
        </div>
      </div>
      <div v-if="SkuRadio == '手动输入'" class="new-input-box" style="height: 282px;">
        <el-input style="width: 400px;" type="textarea" :autosize="{ minRows: 8, maxRows: 8}"
          placeholder="多个sku用英文逗号隔开或者一行一个" v-model="textareaSKU"></el-input>
      </div>
      <div v-if="SkuRadio == '上传文件'" style="margin-bottom: 200px;display: flex;flex-wrap: wrap;">
        <el-upload style="display: flex;align-items: center;" action="" :on-exceed="refile" ref="upload"
          :on-success="handleSuccess" :show-file-list="true" :limit="1" :file-list="fileList"
          accept=".csv, .txt, .xls, .xlsx" :auto-upload="false">
          <!-- :before-upload="beforeUpload" -->
          <jd-button slot="trigger" type="blue" >选择文件</jd-button>
        </el-upload>
        <el-button
          style="color: #2768FF;"
          type="text"
          @click.prevent="openExe">下载导入模板></el-button>
        <!-- <jd-button style="margin-left: 8px;display: flex;align-items: center;" type="text" @click="openExe" label="下载导入模板>"/> -->
        <!-- <div style="width: 100%;"><i class="el-icon-document"></i>测试文件.xlsx</div> -->
      </div>
      <!-- <jd-button label="确认导入" style="margin: 0 8px;" @click="IntoSku"
        type="break" /><span>成功导入{{successSku}}个，失败{{errorSku}}个</span> -->
    </div>
    <!-- 分组sku -->
    <div v-if="fenzuSku">
      <groupSkuBox :venderId="venderId" />

    </div>
    <!-- 底部按钮 -->
    <div class="footer" slot="footer">
      <!-- <button class="cancel" @click.prevent="cancel">取消</button>
      <button class="confirm" @click.prevent="sure">确定</button> -->
      <div v-if="leadIntoSku && !fenzuSku" style="width: 100%;">
          <jd-button  style="margin: 0 16px 0 0;" @click="IntoSku" type="default" >确认导入</jd-button>
          <span>成功导入<span style="color: #2768FF;">{{successSku}}</span>个，失败<span style="color: #2768FF;">{{errorSku}}</span>个</span>
      </div>
      <jd-button  @click="sure" type="blue" v-loading="sureLoading">确定</jd-button>
      <jd-button  @click="cancel" >取消</jd-button>
    </div>

    <!-- 保存分组 -->
    <jd-dialog style="z-index: 4000;" width="500px" title="保存分组" :visible.sync="saveVisible">
      <div>
        <el-radio v-model="saveRadio" label="新建分组">新建分组</el-radio>
        <el-radio v-model="saveRadio" label="已有分组">已有分组</el-radio>
        <div style="display: flex;flex-wrap: nowrap;margin-top: 20px;" v-if="saveRadio=='新建分组'">
          <div style="width: 100px;display: flex;align-items: center;"><span style="color: red;">*</span>分组名称：</div>
          <el-input placeholder="请输入分组名称" v-model="groupName" maxlength="20" show-word-limit />
        </div>
        <div style="display: flex;flex-wrap: nowrap;margin-top: 20px;" v-if="saveRadio=='已有分组'">
          <div style="width: 100px;display: flex;align-items: center;"><span style="color: red;">*</span>选择分组：</div>
          <el-select v-model="selsectGroup" placeholder="请选择">
            <el-option v-for="item in groupOptions" :key="item.groupId" :label="item.groupName" :value="item.groupId">
            </el-option>
          </el-select>
          <!-- <el-input placeholder="请输4入分组名称" v-model="groupName" maxlength="20" show-word-limit /> -->
        </div>
      </div>
      <div slot="footer">
        <jd-button  @click="saveSpuList" type="blue">确定</jd-button>
        <jd-button  @click="saveVisible = false" >取消</jd-button>
      </div>
    </jd-dialog>
    <!-- </el-dialog> -->
  </jd-dialog>
</template>

<script>
import { getSellercats, getTaobaoItemList, getTaobaoItemListSku, addToGroup, getGroupList, SKUinputText, importSkuFile } from "@/api/analysis/ware-controller";
import { synchroJdWare } from "@/api/serviceCenter/popCommentWareAnalysis";
import myPopup from "./myPopup";
import selectGoodsSku from "./selectGoodsSku.vue";
import groupSkuBox from "./groupSkuBox.vue";
import inputForm from "./inputForm";
import { checkProduct } from "@/api/jhk/activity.js";

export default {
  components: {
    myPopup,
    inputForm,
    selectGoodsSku,
    groupSkuBox
  },
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    selectGoods: {
      type: Array,
      default: () => {
        return [];
      },
    }, // 用于回显选中的商品
    selectGoodsSkuList: {
      type: Array,
      default: () => {
        return [];
      },
    }, // 用于回显选中skulist的商品
    moduleType: {
      type: Boolean,
      default: false,
    },
    skuSearch: {
      type: Boolean,
      default: false,
    },
    // sku选择显示
    GoodsSkuIsflay: {
      type: Boolean,
      default: false,
    },
    xianz: {
      type: Boolean,
      default: false,
    },
    limit:{
      type:Number,
      default: 0,
    },
    // 新增店铺id
    venderId: {
      type: Number|String,
      default: ""
    },
    // 判断是否是互动活动
    isInteract: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
  },

  watch: {
    isShow(newVal) {
      console.log(newVal, this.moduleType, 22222);
      this.leadIntoSku = false
      if (newVal && this.moduleType) {   
         console.log("activeName",this.activeName,this.goodsStateSku)
         this.activeName = "2";
         if(this.GoodsSkuIsflay&&!this.venderType){
          setTimeout(() => {
          this.activeName = "1";
          // 1.11
          this.goodsStateSku = false
         },100)
        }else{
          this.goodsStateSku = true
        }

        console.log("watch");
        console.log(this.selectGoods,'组件this.selectGoods');
        this.selectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
        this.showSelectedGoodsList = JSON.parse(JSON.stringify(this.selectGoods));
        if (this.skuSearch) {
          this.ids = this.selectGoods.map((i) => Number(i.skuId));
          console.log(this.ids, this.selectGoods, 22222);
        } else {
          console.log(this.ids, this.selectGoods);
          this.ids = this.selectGoods.map((i) => Number(i.wareId));
        }
        this.$nextTick(() => {
          // this.$refs.inputForm.formSearch();
          this.searchForm();
          this.GroupList()
        });
      }
    },
  },
  data() {
    return {
      sureLoading: false,
      SelectGoodsListSku: [],
      goodsStateSku: false,
      activeName: "1",
      // 1.11 保存分组
      saveVisible: false,
      saveRadio:'新建分组',
      groupName:'',
      groupOptions:[],
      selsectGroup:'',
      // 1.11 导入sku
      filesuccess: false,
      leadIntoSku: false, //导入sku
      fenzuSku: false, //导入sku
      textareaSKU: '', //手动输入sku值
      successSku: 0,
      errorSku: 0,
      SkuRadio: '手动输入',
      fileList: [],
      
      inputData: [
        // 头部查询表单配置项
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          // multiple: this.skuSearch,
          multiple: true,
          width: 260,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID, 多个请用,隔开",
          width: 260,
        },
        {
          name: "商品状态:",
          val: "wareStatus",
          default: '',
          selectArr: [
            { label: "全部", id: '' },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 260,
        },
        {
          name: "商品编码:",
          val: "wareIdStr",
          placeholder: "请输入商品编码，多个请用,隔开",
          width: 260,
        },
        {
          name: "商品名称:",
          val: "wareTitle",
          placeholder: "请输入商品名称",
          width: 260,
        },
      ],
      inputData1: [
        // 头部查询表单配置项
        {
          name: "商品类目:",
          placeholder: "请选择",
          val: "categoryId",
          cascaderArr: [],
          // multiple: this.skuSearch,
          multiple: true,
          width: 260,
        },
        {
          name: "SKU ID:",
          val: "skuId",
          placeholder: "请输入SKU ID, 多个请用,隔开",
          width: 260,
        },
        {
          name: "商品状态:",
          val: "skuStatus",
          default: '',
          selectArr: [
            { label: "全部", id: '' },
            { label: "上架", id: 1 },
            { label: "下架", id: 2 },
          ],
          width: 260,
        },
        {
          name: "商品编码:",
          val: "wareIdStr",
          placeholder: "请输入商品编码，多个请用,隔开",
          width: 260,
        },
        {
          name: "商品名称:",
          val: "skuName",
          placeholder: "请输入商品名称",
          width: 260,
        },
      ],
      total: 0,
      goodsList: [], // 左边店内商品数据

      currentLeftPage: 1, // 左边店内商品当前页

      selectedGoodsList: [], // 右边已选商品数据
      showSelectedGoodsList: [], // 右边显示已选商品

      currentRightPage: 1, // 右边已经商品当前页

      tableLoading: false, //左盒子loading
      tableRightLoading:false, //右盒子loading 仅 按查询结果选择 使用
      ids: [], //已选商品id集合,防止同一个商品可被多次选中

      pageSizeLeft: 5,
      pageSizeRight: 5,
      fromObj: {
        skuStatus: '',
        wareStatus: '',
      },
      formCopy:{},
      allShopList: [],
    };
  },
  created() {
    console.log(this.skuSearch);
    if (this.moduleType) {
      // console.log(this.selectGoods);
      this.selectedGoodsList = this.selectGoods;
      this.ids = this.selectGoods.map((i) => Number(i.wareId));
      // console.log(this.ids);
    }
  },
  mounted() {
    this.init(); //初始化
    // 根据分页size截取数组
    this.sliceArr(this.currentRightPage, this.pageSizeRight);
  },
  methods: {
    refile(file){
      console.log(file[0])
      this.$refs.upload.clearFiles()
      this.$refs.upload.handleStart(file[0]);
    },
    // 获取商品列表
    async GroupList(){
      let res = await getGroupList({
        venderId: this.venderId
      })
      if(res.code==1){
        this.groupOptions = res.data
      }
    },
    // 保存spu分组  
    saveSpuList(){
      let formData={
        groupId:'',
        groupName:'',
        // idList:this.selectedGoodsList,
      }
      if(this.venderId) {
        formData.venderId = this.venderId;
      }

      if(this.saveRadio=='新建分组'){
        if(this.groupName == ''){
          this.$message.warning('分组名称不可为空')
          return
        }
        formData.groupName = this.groupName
      }
      if(this.saveRadio=='已有分组'){
        if(this.selsectGroup == ''){
          this.$message.warning('请选择分组')
          return
        }
        formData.groupId = this.selsectGroup
        this.groupOptions.forEach( item => {
          if(item.groupId == formData.groupId){
            formData.groupName = item.groupName
          }
        })
      }
      formData.idList = this.selectedGoodsList.map(item=>{
        return item.skuList[0].skuId
      })
      addToGroup(formData).then(res=>{
        if(res.code==1){
          this.saveVisible = false
          this.$message.success('创建成功')
          this.GroupList()
        }else{
          this.$message.error(res.message)
        }
      })
    },

    // 保存分组
    saveGoodsList(){
      this.saveVisible = true
      this.groupName = ''
      this.selsectGroup = ''
    },
    // 下载模板文件
    openExe(){
      window.open('https://yeion-public.s3.cn-north-1.jdcloud-oss.com/template/SKU%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx', '_blank');
    },
    // 导入文件
    handleSuccess(){
      this.filesuccess = true
    },
    beforeUpload(file) {
      console.log("---file---")
      console.log(file)
      const fileSize = file.size / 1024 / 1024 < 50;
      if (!fileSize) {
        this.message.warning("上传模板大小不能超过 50MB!");
        return  false;
      }
      let formData = new FormData();
      formData.append('file', file.raw);
      importSkuFile(formData,this.venderId).then(res => {
        if(res.code==1){
            this.$message.success('导入成功！')
            this.$refs.upload.clearFiles()
            this.successSku = res.data.successNum
            this.errorSku = res.data.failNum
            res.data.skuList.forEach( item => {
              let ispush = true
              this.SelectGoodsListSku.forEach(it=>{
                if(it.skuId == item.skuId){
                  ispush = false
                }
              })
              if(ispush){
                this.SelectGoodsListSku.push(item)
              }
            })
          }else{
            this.$message.error(res.message);
          }
      })
      return false;
    },
    // 导出sku
    IntoSku(){
      if(this.SkuRadio == '手动输入'){
        let lines = this.textareaSKU.split('\n');  
        let finalArray = lines.flatMap(line => line.split(','));  
        finalArray = finalArray.map(item => item.trim());
        let skuId = finalArray.join(',')
        SKUinputText({
          skuId:skuId,
          venderId: this.venderId
        }).then( res=>{
          if(res.code==1){
            this.$message.success('导入成功！')
            this.successSku = res.data.successNum
            this.errorSku = res.data.failNum
            res.data.skuList.forEach( item => {
              let ispush = true
              this.SelectGoodsListSku.forEach(it=>{
                if(it.skuId == item.skuId){
                  ispush = false
                }
              })
              if(ispush){
                this.SelectGoodsListSku.push(item)
              }
            })
          }else{
            this.$message.error(res.message);
          }
        })
      }
      if(this.SkuRadio == '上传文件'){
        this.beforeUpload(this.$refs.upload.uploadFiles[0])
      }
    },
    init() {
      // 获取商品类目
      getSellercats().then((res) => {
        let data = this.transverter(res.data);
        this.getTrees(data);
        let list = data.filter((item) => item.parent_id == 0);
        console.log("list", list);
        let cascaderArr = list.map((item) => {
          return {
            label: item.label,
            value: item.value,
            children: item.children,
          };
        });
        console.dir(cascaderArr);

        this.inputData[0].cascaderArr = cascaderArr;
        this.inputData1[0].cascaderArr = cascaderArr;
        // console.log(this.inputData[0]);
      });
      this.$nextTick(() => {
        // this.$refs.inputForm.formSearch();
        this.searchForm();
      });
      setTimeout(async () => {
        this.SelectGoodsListSku = this.selectGoodsSkuList;
        this.$refs.SelectGoodsSku.selectedGoodsList = this.selectGoodsSkuList;
        if(this.GoodsSkuIsflay&&!this.venderType){
        }else{
          this.goodsStateSku = true;
          this.leadIntoSku = false;
          this.activeName = '2'
          console.log("???")
        }
        // console.log(this.$refs.SelectGoodsSku.selectedGoodsList, 66666666666);
      }, 500);
    },
    sure() {
      let param = this.$refs.SelectGoodsSku.selectedGoodsList.map((res) => {
        return {
          ...res,
          price: res.jdPrice || res.price,
          wareId: null,
          wareLogo: res.logo,
          wareTitle: res.wareTitle,
          skuId: res.skuId,
        };
      });
      if (this.isInteract) {
        const skuIds = param.map((v) => v.skuId);
        if (skuIds.length == 0) {
          this.$emit("close", param);
          return;
        }
        this.sureLoading = true;
        checkProduct(skuIds)
          .then((res) => {
            this.sureLoading = false;
            if (res.code == 1) {
              if (res.data.isHave) {
                this.$message.warning("活动暂不支持选择虚拟套装和影分身商品");
              } else {
                if(!this.venderType && this.GoodsSkuIsflay){
                  console.log("选中商品", this.selectedGoodsList, param);
                  this.$emit("close", this.selectedGoodsList, param);
                }else{
                    this.$emit("close", param);
                }
              }
            } else {
              this.$message.warning(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
            this.sureLoading = false;
          });
        return;
      }
      if(!this.venderType && this.GoodsSkuIsflay){
        console.log("选中商品", this.selectedGoodsList, param);
        this.$emit("close", this.selectedGoodsList, param);
      }else{
          this.$emit("close", param);
      }
    },
    cancel() {
      this.$emit("close", false);
    },
    transverter(data) {
      // 排重
      let obj = {};
      for (let i = 0; i < data.length; i++) {
        obj[data[i]["categoryId"]] = data[i];
      }
      let arr = Object.values(obj);
      var newData = [];
      // console.log(arr);
      for (var i = 0; i < arr.length; i++) {
        newData[i] = {
          value: arr[i].categoryId,
          parent_id: arr[i].parentId,
          label: arr[i].name,
          isChecked: false,
        };
      }
      return newData;
    },
    getTrees(list, parent_id = 0) {
      let parentObj = {};
      list.forEach((o) => {
        parentObj[o.id] = o;
      });
      if (!parent_id) {
        return list
          .filter((o) => !parentObj[o.parent_id])
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      } else {
        return list
          .filter((o) => o.parent_id == parent_id)
          .map((o) => {
            if (this.getTrees(list, o.value).length == 0) {
              // console.log(this.getTrees(list, o.value).length);
              delete o.children;
              return o;
            } else {
              return (o.children = this.getTrees(list, o.value)), o;
            }
          });
      }
    },
    /**
     * 弹窗隐藏
     */
    popupClose() {
      this.$emit("close", false);
      this.fenzuSku = false;
      this.activeName = "1";
    },
    /**
     * 表单查询商品列表
     */
    searchForm(form = this.fromObj) {
      console.log(this.fromObj, 5555);
      this.tableLoading = true;
      form.current = this.currentLeftPage;
      if (form.categoryId) {
        form.categoryId = form.categoryId;
      }
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          size: this.pageSizeLeft,
          venderId: this.venderId
        }).then((res) => {
          this.tableLoading = false;
          if (res.code == 1) {
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                // const state = this.ids.includes(item.skuId);
                // const state = this.ids.indexOf(item.skuId);
                this.ids.forEach((ele) => {
                  if (ele == item.skuId) {
                    item.isAdd = true;
                  }
                });
              });
            }
            // console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      } else {
        getTaobaoItemList({
          ...form,
          page: form.current,
          pageSize: this.pageSizeLeft,
          venderId: this.venderId
        }).then((res) => {
          this.tableLoading = false;
          if (res.data == null) {
            this.goodsList = [];
          }
          if (res.code == 1) {
            this.goodsList = res.data.records;
            if (this.moduleType) {
              // console.log(this.ids);
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId);
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            // function myIsNaN(value) {
            //     return typeof value === 'number' && !isNaN(value);
            // }
            this.sliceArr(this.currentRightPage, this.pageSizeRight);
            // console.log(res.data.records);
            this.total = +res.data.total;
          } else {
            this.goodsList = [];
          }
        });
      }
    },
    handleSearch(form, isSearch = false) {
      this.fromObj = form;
      this.currentLeftPage = 1;
      console.log(form, 5555);
      this.tableLoading = true;
      form.current = this.currentLeftPage;
      form.categoryId = typeof form.categoryId == "object" && form.categoryId.length ? form.categoryId.join(",") : form.categoryId;
      // if (isSearch) {
      //   form.current = 1;
      // }
      this.formCopy = JSON.parse(JSON.stringify(form))
      if (Array.isArray(form.categoryId) && form.categoryId.length === 0) {
        form.categoryId = '';
      }
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          size: this.pageSizeLeft,
          venderId: this.venderId
        }).then((res) => {
          this.tableLoading = false;
          if (res.code == 1) {
            // console.log(res.data.records);
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.skuId);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            console.log(res.data.records);
            this.total = +res.data.total;

          } else {
            this.goodsList = [];
          }
        });
      } else {
        // console.log(this.pageSizeLeft);
        getTaobaoItemList({
          ...form,
          page: form.current,
          pageSize: this.pageSizeLeft,
          venderId: this.venderId
        }).then((res) => {
          console.log(res.data);
          this.tableLoading = false;
          if (res.data == null) {
            this.goodsList = [];
          }
          if (res.code == 1) {
            this.goodsList = res.data.records;
            if (this.moduleType) {
              this.goodsList.forEach((item) => {
                // console.log(item.wareId);
                // 避免直接赋值导致左右两侧商品盒子数组地址不一致，状态没有同步响应
                const state = this.ids.includes(item.wareId);
                // console.log(state);
                if (state) {
                  item.isAdd = true;
                }
              });
            }
            // function myIsNaN(value) {
            //     return typeof value === 'number' && !isNaN(value);
            // }
            this.sliceArr(this.currentRightPage, this.pageSizeRight);
            console.log(res.data.records);
            this.total = +res.data.total;
          
          } else {
            this.goodsList = [];
          }
        });
      }
    },
    // 所有商品
    allShop() {
      let form = this.formCopy;
      let total = this.total;
      if (total >= 10000) {
        this.$message.warning("按结果选择商品不能超过10000个");
        return;
      }
      this.tableRightLoading = true;
      if (this.skuSearch) {
        getTaobaoItemListSku({
          ...form,
          current: 1,
          size: total,
          venderId: this.venderId
        }).then((res) => {
          if (res.code == 1) {
            // console.log(res.data.records);
            res.data.records.map((item) => {
              item.wareTitle = item.skuName;
            });
            
            this.selectAllshop(res.data.records)
          } else {
            this.$message.warning(res.message);
          }
          this.tableRightLoading = false;
        });
      } else {
        getTaobaoItemList({
          ...form,
          page: 1,
          pageSize: total,
          current: 1,
          size: total,
          venderId: this.venderId
        }).then((res) => {
          if (res.data == null) {
            this.allShopList = [];
          }
          if (res.code == 1) {
            
            this.selectAllshop(res.data.records)
          } else {
            this.$message.warning(res.message);
          }
          this.tableRightLoading = false;
        });
      }
    },
    /**
     * 更新商品
     */
    updateGoods() {
      //
      synchroJdWare().then((res) => {
        console.log(res);
        if (res.code == "1") {
          this.$message.success("正在同步店铺商品");
        } else {
          this.$message.warning(res.message);
        }
      });
      // this.$refs.inputForm.formSearch();
    },
    /**
     * 添加商品
     */
    addGoods(item) {
      console.log(item);
      if (this.xianz && this.selectedGoodsList.length >= 20) {
        this.$message.warning("选择商品不能超过20个");
        return;
      }
      if (this.limit && this.selectedGoodsList.length >= this.limit) {
        this.$message.warning(`不能超过${this.limit}个`);
        return;
      }
      if (item.isAdd) return;
      item.isAdd = true;
      if (this.skuSearch) {
        this.ids.push(item.skuId);
      } else {
        this.ids.push(item.wareId);
      }

      this.selectedGoodsList.push(item);
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
      // console.log(this.ids);
      // console.log(this.selectedGoodsList);
    },
    /**
     * 全选
     */
    selectAll() {
      this.goodsList.forEach((item) => {
        if (this.xianz && this.selectedGoodsList.length >= 20) {
          this.$message.warning("选择商品不能超过20个");
          return;
        }
        if (this.limit && this.selectedGoodsList.length >= this.limit) {
          this.$message.warning(`不能超过${this.limit}个`);
          return;
        }
        if (!item.isAdd) {
          item.isAdd = true;
          this.selectedGoodsList.push(item);
          // sku维度
          if (this.skuSearch) {
            this.ids.push(item.skuId);
          } else {
            this.ids.push(item.wareId);

          }
        }
      });

      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    // 按结果全选
    selectAllshop(list) {
      // this.selectedGoodsList = [];
      if (list.length >= 10000) {
        this.$message.warning("按结果选择商品不能超过10000个");
        return;
      }
      this.goodsList.forEach((val) => {
        val.isAdd = true;
      });
      this.selectedGoodsList = [];
      this.ids = [];
      list.forEach((item) => {
        this.selectedGoodsList.push(item);
          // sku维度
          if (this.skuSearch) {
            this.ids.push(item.skuId);
          } else {
            this.ids.push(item.wareId);
          }
      });

      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 左边商品盒子分页事件
     */
    handleLeftSizeChange(val) {
      this.pageSizeLeft = val;
      this.currentLeftPage = 1;
      // this.$refs.inputForm.formSearch();
      this.searchForm();
    },
    handleLeftCurrentChange(val) {
      this.currentLeftPage = val;
      // this.$refs.inputForm.formSearch();
      this.searchForm();
    },
    /**
     * 删除商品
     */
    clearGoods(item, index) {
      console.log(item.wareId);
      if (this.skuSearch) {
        this.goodsList.forEach((i) => {
          if (i.skuId == item.skuId) {
            i.isAdd = false;
          }
        });
        // this.allShopList.forEach((i) => {
        //   if (i.skuId == item.skuId) {
        //     i.isAdd = false;
        //   }
        // });
      } else {
        this.goodsList.forEach((i) => {
          if (i.wareId == item.wareId) {
            i.isAdd = false;
          }
        });
        // this.allShopList.forEach((i) => {
        //   if (i.wareId == item.wareId) {
        //     i.isAdd = false;
        //   }
        // });
      }
      if (this.moduleType) {
        if (this.skuSearch) {
          this.ids.splice(
            this.ids.findIndex((i) => i === item.skuId),
            1
          );
        } else {
          this.ids.splice(
            this.ids.findIndex((i) => i === item.wareId),
            1
          );
        }
      }
      if (this.skuSearch) {
        this.selectedGoodsList.forEach((e, i) => {
          if (e.skuId === item.skuId) {
            this.selectedGoodsList.splice(i, 1);
          }
        });
      } else {
        this.selectedGoodsList.forEach((e, i) => {
          if (e.wareId === item.wareId) {
            this.selectedGoodsList.splice(i, 1);
          }
        });
      }
      // this.selectedGoodsList.splice(index, 1);
      this.sliceArr(this.currentRightPage, this.pageSizeRight);
    },
    /**
     * 清空
     */
    empty() {
      console.log(this.ids);
      // return
      if (this.skuSearch) {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.skuId)) {
            item.isAdd = false;
          }
        });
      } else {
        this.goodsList.forEach((item, index) => {
          if (this.ids.includes(item.wareId)) {
            item.isAdd = false;
          }
        });
      }
      // this.allShopList.forEach((item) => {
      //   item.isAdd = false;
      // });
      // this.selectedGoodsList.length = 0;
      console.log(this.goodsList);
      this.ids = [];
      this.selectedGoodsList = [];
      this.showSelectedGoodsList = [];
    },
    /**
     * 右边商品盒子分页事件
     */
    handleRigthSizeChange(val) {
      this.pageSizeRight = val;
      // 分页size大于右商品盒子数组长度时
      if (this.currentRightPage * this.pageSizeRight > this.selectedGoodsList.length) {
        this.sliceArr(1, this.selectedGoodsList.length);
      } else {
        this.sliceArr(1, val);
      }
    },
    // 右边商品盒子页码事件
    handleRightCurrentChange(val) {
      this.currentRightPage = val;
      this.sliceArr(val, this.pageSizeRight);
    },
    // 根据分页信息截取数组进行显示
    sliceArr(current, size) {
      this.showSelectedGoodsList = this.selectedGoodsList.slice(size * (current - 1), size * current);
      console.log(this.showSelectedGoodsList);
    },
    handleClick(tab) {
      if (tab.name == "1") {
        this.goodsStateSku = false;
        this.leadIntoSku = false;
      }
      if (tab.name == "2") {
        // this.SelectGoodsListSku = this.$refs.SelectGoodsSku.selectedGoodsList;
        this.goodsStateSku = true;
        this.leadIntoSku = false;
      }
      if (tab.name == "3") {
        // this.SelectGoodsListSku = this.$refs.SelectGoodsSku.selectedGoodsList;
        this.leadIntoSku = true;
      }
      if (tab.name == "4") {
        this.fenzuSku = true;
      }else {
        this.fenzuSku = false;
      }
      this.SelectGoodsListSku = this.$refs.SelectGoodsSku.selectedGoodsList;
      // this.goodsStateSku = !this.goodsStateSku;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .popup{
  margin: 8vh auto 0 !important;
}

button {
  margin: 0;
  padding: 0 12px;
  height: 32px;
  line-height: 30px;
  border: none;
  outline: none;
  border-radius: 3px;
  background-color: #fff;
  text-align: center;
  cursor: pointer;
}
.notData {
  text-align: center;
  color: #909399;
  margin-top: 20%;
}

.headSearchForm {
  // margin-top: 20px;
}

.goodsContent {
  display: flex;
  align-items: center;
  justify-content: center;
  .left{
    flex: 1;
    margin-right: 12px;
  }
  .left,
  .right {
    width: 480px;
    .titleBox {
      position: relative;
      width: 100%;
      height: 48px;
      line-height: 48px;
      color: #1F1F1F;
      font-size: 14px;
      background: #F8F9FA;
      border-radius: 4px 4px 0px 0px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      padding: 0 12px;
      .tit{
        color: #1F1F1F;
        font-size: 14px;
      }
      .all,
      .clear {
        position: absolute;
        right: 10px;
        color: #2768FF;
        cursor: pointer;
      }
      .update {
        // margin-left: -200px;
        position: absolute;
        left: 10px;
        top: 4px;
        width: 70px;
        font-size: 14px;
        height: 28px;
        color: #ffffff;
        background-color: #2768FF;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #2768FF;
        }
      }
    }
    .goodsScrollBox {
      height: 334px;
      overflow: auto;
      position: relative;
      &::-webkit-scrollbar {
        width: 8px;
        height: 10px;
      }
      &::-webkit-scrollbar-track {
        background: rgba(246, 246, 246, 1);
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ddd;
      }
      .goods {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        justify-content: space-between;
        padding: 0 12px;
        height: 64px;
        border-left: 1px solid #f3f3f3;
        border-right: 1px solid #f3f3f3;
        border-bottom: 1px solid #f3f3f3;
        transition: all 0.2s;
        position: relative;
        a {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          // padding: 0 16px;
          height: 64px;
          flex: 1;
        }
        .avar {
          flex-shrink: 0;
          width: 48px;
          height: 48px;
          background-color: #f9f9f9;
        }
        .desc {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin: 0 0 0 8px;
          .goodsName {
            color: #666666;
            font-size: 14px;
            margin: 0 0 8px 0;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            // -webkit-line-clamp: 2;
            line-height: 15px;
            
            // display: -webkit-box;
            // -webkit-box-orient: vertica;
            // overflow: hidden;
            // text-overflow: ellipsis;
          }
          .foot {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .goodsId {
              font-size: 13px;
              color: #666666;
            }
            .money {
              font-size: 13px;
              color: #333333;
              margin-right: 16px;
            }
          }
        }
        .addIcon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
          transition: all 0.2s;
          position: absolute;
          top: 30px;
          right: 12px;
        }
        .clearIcon {
          flex-shrink: 0;
          width: 20px;
          height: 20px;
          cursor: pointer;
          position: absolute;
          top: 30px;
          right: 12px;
        }
      }
      .isAdd {
        background-color: #f9f9f9 !important;
        .addIcon {
          opacity: 0.3;
          cursor: not-allowed;
        }
      }
      .noDataBox {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
  .left {
  }
  .right {
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  // margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}
</style>
<!-- <style lang="scss">
.el-select-dropdown {
  z-index: 3334 !important;
}
</style> -->
